module.exports = __webpack_public_path__ + "assets/Heebo-Medium.b4e0045784568bc212a3bb6de08891ff.ttf";